// Country to Flag Emoji mapping - Comprehensive worldwide list
// Includes both English and Dutch country names
const countryFlags = {
  // A
  'Afghanistan': '🇦🇫',
  'Albania': '🇦🇱',
  'Albanië': '🇦🇱',
  'Algeria': '🇩🇿',
  'Algerije': '🇩🇿',
  'Andorra': '🇦🇩',
  'Angola': '🇦🇴',
  'Antigua and Barbuda': '🇦🇬',
  'Argentina': '🇦🇷',
  'Argentinië': '🇦🇷',
  'Armenia': '🇦🇲',
  'Armenië': '🇦🇲',
  'Australia': '🇦🇺',
  'Australië': '🇦🇺',
  'Austria': '🇦🇹',
  'Oostenrijk': '🇦🇹',
  'Azerbaijan': '🇦🇿',
  'Azerbeidzjan': '🇦🇿',
  // B
  'Bahamas': '🇧🇸',
  'Bahrain': '🇧🇭',
  'Bahrein': '🇧🇭',
  'Bangladesh': '🇧🇩',
  'Barbados': '🇧🇧',
  'Belarus': '🇧🇾',
  'Wit-Rusland': '🇧🇾',
  'Belgium': '🇧🇪',
  'België': '🇧🇪',
  'Belize': '🇧🇿',
  'Benin': '🇧🇯',
  'Bhutan': '🇧🇹',
  'Bolivia': '🇧🇴',
  'Bosnia and Herzegovina': '🇧🇦',
  'Bosnia': '🇧🇦',
  'Bosnië': '🇧🇦',
  'Bosnië en Herzegovina': '🇧🇦',
  'Botswana': '🇧🇼',
  'Brazil': '🇧🇷',
  'Brazilië': '🇧🇷',
  'Brunei': '🇧🇳',
  'Bulgaria': '🇧🇬',
  'Bulgarije': '🇧🇬',
  'Burkina Faso': '🇧🇫',
  'Burundi': '🇧🇮',
  // C
  'Cambodia': '🇰🇭',
  'Cambodja': '🇰🇭',
  'Cameroon': '🇨🇲',
  'Kameroen': '🇨🇲',
  'Canada': '🇨🇦',
  'Cape Verde': '🇨🇻',
  'Kaapverdië': '🇨🇻',
  'Central African Republic': '🇨🇫',
  'Centraal-Afrikaanse Republiek': '🇨🇫',
  'Chad': '🇹🇩',
  'Tsjaad': '🇹🇩',
  'Chile': '🇨🇱',
  'Chili': '🇨🇱',
  'China': '🇨🇳',
  'Colombia': '🇨🇴',
  'Comoros': '🇰🇲',
  'Comoren': '🇰🇲',
  'Congo': '🇨🇬',
  'Costa Rica': '🇨🇷',
  'Croatia': '🇭🇷',
  'Kroatië': '🇭🇷',
  'Cuba': '🇨🇺',
  'Cyprus': '🇨🇾',
  'Czech Republic': '🇨🇿',
  'Czechia': '🇨🇿',
  'Tsjechië': '🇨🇿',
  // D
  'Denmark': '🇩🇰',
  'Denemarken': '🇩🇰',
  'Djibouti': '🇩🇯',
  'Dominica': '🇩🇲',
  'Dominican Republic': '🇩🇴',
  'Dominicaanse Republiek': '🇩🇴',
  // E
  'Ecuador': '🇪🇨',
  'Egypt': '🇪🇬',
  'Egypte': '🇪🇬',
  'El Salvador': '🇸🇻',
  'Equatorial Guinea': '🇬🇶',
  'Equatoriaal-Guinea': '🇬🇶',
  'Eritrea': '🇪🇷',
  'Estonia': '🇪🇪',
  'Estland': '🇪🇪',
  'Eswatini': '🇸🇿',
  'Ethiopia': '🇪🇹',
  'Ethiopië': '🇪🇹',
  // F
  'Fiji': '🇫🇯',
  'Finland': '🇫🇮',
  'France': '🇫🇷',
  'Frankrijk': '🇫🇷',
  // G
  'Gabon': '🇬🇦',
  'Gambia': '🇬🇲',
  'Georgia': '🇬🇪',
  'Georgië': '🇬🇪',
  'Germany': '🇩🇪',
  'Duitsland': '🇩🇪',
  'Ghana': '🇬🇭',
  'Greece': '🇬🇷',
  'Griekenland': '🇬🇷',
  'Grenada': '🇬🇩',
  'Guatemala': '🇬🇹',
  'Guinea': '🇬🇳',
  'Guinea-Bissau': '🇬🇼',
  'Guyana': '🇬🇾',
  // H
  'Haiti': '🇭🇹',
  'Haïti': '🇭🇹',
  'Honduras': '🇭🇳',
  'Hungary': '🇭🇺',
  'Hongarije': '🇭🇺',
  // I
  'Iceland': '🇮🇸',
  'IJsland': '🇮🇸',
  'India': '🇮🇳',
  'Indonesia': '🇮🇩',
  'Indonesië': '🇮🇩',
  'Iran': '🇮🇷',
  'Iraq': '🇮🇶',
  'Irak': '🇮🇶',
  'Ireland': '🇮🇪',
  'Ierland': '🇮🇪',
  'Israel': '🇮🇱',
  'Israël': '🇮🇱',
  'Italy': '🇮🇹',
  'Italië': '🇮🇹',
  'Ivory Coast': '🇨🇮',
  'Ivoorkust': '🇨🇮',
  // J
  'Jamaica': '🇯🇲',
  'Japan': '🇯🇵',
  'Jordan': '🇯🇴',
  'Jordanië': '🇯🇴',
  // K
  'Kazakhstan': '🇰🇿',
  'Kazachstan': '🇰🇿',
  'Kenya': '🇰🇪',
  'Kenia': '🇰🇪',
  'Kiribati': '🇰🇮',
  'Kuwait': '🇰🇼',
  'Koeweit': '🇰🇼',
  'Kyrgyzstan': '🇰🇬',
  'Kirgizië': '🇰🇬',
  'Korea': '🇰🇷',
  'South Korea': '🇰🇷',
  'Zuid-Korea': '🇰🇷',
  'North Korea': '🇰🇵',
  'Noord-Korea': '🇰🇵',
  // L
  'Laos': '🇱🇦',
  'Latvia': '🇱🇻',
  'Letland': '🇱🇻',
  'Lebanon': '🇱🇧',
  'Libanon': '🇱🇧',
  'Lesotho': '🇱🇸',
  'Liberia': '🇱🇷',
  'Libya': '🇱🇾',
  'Libië': '🇱🇾',
  'Liechtenstein': '🇱🇮',
  'Lithuania': '🇱🇹',
  'Litouwen': '🇱🇹',
  'Luxembourg': '🇱🇺',
  'Luxemburg': '🇱🇺',
  // M
  'Madagascar': '🇲🇬',
  'Malawi': '🇲🇼',
  'Malaysia': '🇲🇾',
  'Maleisië': '🇲🇾',
  'Maldives': '🇲🇻',
  'Malediven': '🇲🇻',
  'Mali': '🇲🇱',
  'Malta': '🇲🇹',
  'Marshall Islands': '🇲🇭',
  'Marshalleilanden': '🇲🇭',
  'Mauritania': '🇲🇷',
  'Mauritanië': '🇲🇷',
  'Mauritius': '🇲🇺',
  'Mexico': '🇲🇽',
  'Micronesia': '🇫🇲',
  'Micronesië': '🇫🇲',
  'Moldova': '🇲🇩',
  'Moldavië': '🇲🇩',
  'Monaco': '🇲🇨',
  'Mongolia': '🇲🇳',
  'Mongolië': '🇲🇳',
  'Montenegro': '🇲🇪',
  'Morocco': '🇲🇦',
  'Marokko': '🇲🇦',
  'Mozambique': '🇲🇿',
  'Myanmar': '🇲🇲',
  // N
  'Namibia': '🇳🇦',
  'Namibië': '🇳🇦',
  'Nauru': '🇳🇷',
  'Nepal': '🇳🇵',
  'Netherlands': '🇳🇱',
  'Nederland': '🇳🇱',
  'New Zealand': '🇳🇿',
  'Nieuw-Zeeland': '🇳🇿',
  'Nicaragua': '🇳🇮',
  'Niger': '🇳🇪',
  'Nigeria': '🇳🇬',
  'Norway': '🇳🇴',
  'Noorwegen': '🇳🇴',
  // O
  'Oman': '🇴🇲',
  // P
  'Pakistan': '🇵🇰',
  'Palau': '🇵🇼',
  'Palestine': '🇵🇸',
  'Palestina': '🇵🇸',
  'Panama': '🇵🇦',
  'Papua New Guinea': '🇵🇬',
  'Papoea-Nieuw-Guinea': '🇵🇬',
  'Paraguay': '🇵🇾',
  'Peru': '🇵🇪',
  'Philippines': '🇵🇭',
  'Filipijnen': '🇵🇭',
  'Poland': '🇵🇱',
  'Polen': '🇵🇱',
  'Portugal': '🇵🇹',
  // Q
  'Qatar': '🇶🇦',
  // R
  'Romania': '🇷🇴',
  'Roemenië': '🇷🇴',
  'Russia': '🇷🇺',
  'Rusland': '🇷🇺',
  'Rwanda': '🇷🇼',
  // S
  'Saint Kitts and Nevis': '🇰🇳',
  'Saint Lucia': '🇱🇨',
  'Saint Vincent': '🇻🇨',
  'Samoa': '🇼🇸',
  'San Marino': '🇸🇲',
  'Sao Tome and Principe': '🇸🇹',
  'Saudi Arabia': '🇸🇦',
  'Saoedi-Arabië': '🇸🇦',
  'Senegal': '🇸🇳',
  'Serbia': '🇷🇸',
  'Servië': '🇷🇸',
  'Seychelles': '🇸🇨',
  'Seychellen': '🇸🇨',
  'Sierra Leone': '🇸🇱',
  'Singapore': '🇸🇬',
  'Slovakia': '🇸🇰',
  'Slowakije': '🇸🇰',
  'Slovenia': '🇸🇮',
  'Slovenië': '🇸🇮',
  'Solomon Islands': '🇸🇧',
  'Salomonseilanden': '🇸🇧',
  'Somalia': '🇸🇴',
  'Somalië': '🇸🇴',
  'South Africa': '🇿🇦',
  'Zuid-Afrika': '🇿🇦',
  'South Sudan': '🇸🇸',
  'Zuid-Soedan': '🇸🇸',
  'Spain': '🇪🇸',
  'Spanje': '🇪🇸',
  'Sri Lanka': '🇱🇰',
  'Sudan': '🇸🇩',
  'Soedan': '🇸🇩',
  'Suriname': '🇸🇷',
  'Sweden': '🇸🇪',
  'Zweden': '🇸🇪',
  'Switzerland': '🇨🇭',
  'Zwitserland': '🇨🇭',
  'Syria': '🇸🇾',
  'Syrië': '🇸🇾',
  // T
  'Taiwan': '🇹🇼',
  'Tajikistan': '🇹🇯',
  'Tadzjikistan': '🇹🇯',
  'Tanzania': '🇹🇿',
  'Thailand': '🇹🇭',
  'Timor-Leste': '🇹🇱',
  'Oost-Timor': '🇹🇱',
  'Togo': '🇹🇬',
  'Tonga': '🇹🇴',
  'Trinidad and Tobago': '🇹🇹',
  'Trinidad en Tobago': '🇹🇹',
  'Tunisia': '🇹🇳',
  'Tunesië': '🇹🇳',
  'Turkey': '🇹🇷',
  'Turkije': '🇹🇷',
  'Turkmenistan': '🇹🇲',
  'Tuvalu': '🇹🇻',
  // U
  'Uganda': '🇺🇬',
  'Oeganda': '🇺🇬',
  'Ukraine': '🇺🇦',
  'Oekraïne': '🇺🇦',
  'United Arab Emirates': '🇦🇪',
  'Verenigde Arabische Emiraten': '🇦🇪',
  'UAE': '🇦🇪',
  'VAE': '🇦🇪',
  'Abu Dhabi': '🇦🇪',
  'United Kingdom': '🇬🇧',
  'Verenigd Koninkrijk': '🇬🇧',
  'Great Britain': '🇬🇧',
  'Groot-Brittannië': '🇬🇧',
  'UK': '🇬🇧',
  'United States': '🇺🇸',
  'Verenigde Staten': '🇺🇸',
  'USA': '🇺🇸',
  'Miami': '🇺🇸',
  'Las Vegas': '🇺🇸',
  'Uruguay': '🇺🇾',
  'Uzbekistan': '🇺🇿',
  'Oezbekistan': '🇺🇿',
  // V
  'Vanuatu': '🇻🇺',
  'Vatican': '🇻🇦',
  'Vaticaanstad': '🇻🇦',
  'Venezuela': '🇻🇪',
  'Vietnam': '🇻🇳',
  // Y
  'Yemen': '🇾🇪',
  'Jemen': '🇾🇪',
  // Z
  'Zambia': '🇿🇲',
  'Zimbabwe': '🇿🇼',
};

// Country code mapping for flag images (flagcdn.com) - Comprehensive worldwide list
// Includes both English and Dutch country names
const countryCodeMap = {
  // A
  'Afghanistan': 'af',
  'Albania': 'al',
  'Albanië': 'al',
  'Algeria': 'dz',
  'Algerije': 'dz',
  'Andorra': 'ad',
  'Angola': 'ao',
  'Antigua and Barbuda': 'ag',
  'Argentina': 'ar',
  'Argentinië': 'ar',
  'Armenia': 'am',
  'Armenië': 'am',
  'Australia': 'au',
  'Australië': 'au',
  'Austria': 'at',
  'Oostenrijk': 'at',
  'Azerbaijan': 'az',
  'Azerbeidzjan': 'az',
  // B
  'Bahamas': 'bs',
  'Bahrain': 'bh',
  'Bahrein': 'bh',
  'Bangladesh': 'bd',
  'Barbados': 'bb',
  'Belarus': 'by',
  'Wit-Rusland': 'by',
  'Belgium': 'be',
  'België': 'be',
  'Belize': 'bz',
  'Benin': 'bj',
  'Bhutan': 'bt',
  'Bolivia': 'bo',
  'Bosnia and Herzegovina': 'ba',
  'Bosnia': 'ba',
  'Bosnië': 'ba',
  'Bosnië en Herzegovina': 'ba',
  'Botswana': 'bw',
  'Brazil': 'br',
  'Brazilië': 'br',
  'Brunei': 'bn',
  'Bulgaria': 'bg',
  'Bulgarije': 'bg',
  'Burkina Faso': 'bf',
  'Burundi': 'bi',
  // C
  'Cambodia': 'kh',
  'Cambodja': 'kh',
  'Cameroon': 'cm',
  'Kameroen': 'cm',
  'Canada': 'ca',
  'Cape Verde': 'cv',
  'Kaapverdië': 'cv',
  'Central African Republic': 'cf',
  'Centraal-Afrikaanse Republiek': 'cf',
  'Chad': 'td',
  'Tsjaad': 'td',
  'Chile': 'cl',
  'Chili': 'cl',
  'China': 'cn',
  'Colombia': 'co',
  'Comoros': 'km',
  'Comoren': 'km',
  'Congo': 'cg',
  'Costa Rica': 'cr',
  'Croatia': 'hr',
  'Kroatië': 'hr',
  'Cuba': 'cu',
  'Cyprus': 'cy',
  'Czech Republic': 'cz',
  'Czechia': 'cz',
  'Tsjechië': 'cz',
  // D
  'Denmark': 'dk',
  'Denemarken': 'dk',
  'Djibouti': 'dj',
  'Dominica': 'dm',
  'Dominican Republic': 'do',
  'Dominicaanse Republiek': 'do',
  // E
  'Ecuador': 'ec',
  'Egypt': 'eg',
  'Egypte': 'eg',
  'El Salvador': 'sv',
  'Equatorial Guinea': 'gq',
  'Equatoriaal-Guinea': 'gq',
  'Eritrea': 'er',
  'Estonia': 'ee',
  'Estland': 'ee',
  'Eswatini': 'sz',
  'Ethiopia': 'et',
  'Ethiopië': 'et',
  // F
  'Fiji': 'fj',
  'Finland': 'fi',
  'France': 'fr',
  'Frankrijk': 'fr',
  // G
  'Gabon': 'ga',
  'Gambia': 'gm',
  'Georgia': 'ge',
  'Georgië': 'ge',
  'Germany': 'de',
  'Duitsland': 'de',
  'Ghana': 'gh',
  'Greece': 'gr',
  'Griekenland': 'gr',
  'Grenada': 'gd',
  'Guatemala': 'gt',
  'Guinea': 'gn',
  'Guinea-Bissau': 'gw',
  'Guyana': 'gy',
  // H
  'Haiti': 'ht',
  'Haïti': 'ht',
  'Honduras': 'hn',
  'Hungary': 'hu',
  'Hongarije': 'hu',
  // I
  'Iceland': 'is',
  'IJsland': 'is',
  'India': 'in',
  'Indonesia': 'id',
  'Indonesië': 'id',
  'Iran': 'ir',
  'Iraq': 'iq',
  'Irak': 'iq',
  'Ireland': 'ie',
  'Ierland': 'ie',
  'Israel': 'il',
  'Israël': 'il',
  'Italy': 'it',
  'Italië': 'it',
  'Ivory Coast': 'ci',
  'Ivoorkust': 'ci',
  // J
  'Jamaica': 'jm',
  'Japan': 'jp',
  'Jordan': 'jo',
  'Jordanië': 'jo',
  // K
  'Kazakhstan': 'kz',
  'Kazachstan': 'kz',
  'Kenya': 'ke',
  'Kenia': 'ke',
  'Kiribati': 'ki',
  'Kuwait': 'kw',
  'Koeweit': 'kw',
  'Kyrgyzstan': 'kg',
  'Kirgizië': 'kg',
  'Korea': 'kr',
  'South Korea': 'kr',
  'Zuid-Korea': 'kr',
  'North Korea': 'kp',
  'Noord-Korea': 'kp',
  // L
  'Laos': 'la',
  'Latvia': 'lv',
  'Letland': 'lv',
  'Lebanon': 'lb',
  'Libanon': 'lb',
  'Lesotho': 'ls',
  'Liberia': 'lr',
  'Libya': 'ly',
  'Libië': 'ly',
  'Liechtenstein': 'li',
  'Lithuania': 'lt',
  'Litouwen': 'lt',
  'Luxembourg': 'lu',
  'Luxemburg': 'lu',
  // M
  'Madagascar': 'mg',
  'Malawi': 'mw',
  'Malaysia': 'my',
  'Maleisië': 'my',
  'Maldives': 'mv',
  'Malediven': 'mv',
  'Mali': 'ml',
  'Malta': 'mt',
  'Marshall Islands': 'mh',
  'Marshalleilanden': 'mh',
  'Mauritania': 'mr',
  'Mauritanië': 'mr',
  'Mauritius': 'mu',
  'Mexico': 'mx',
  'Micronesia': 'fm',
  'Micronesië': 'fm',
  'Moldova': 'md',
  'Moldavië': 'md',
  'Monaco': 'mc',
  'Mongolia': 'mn',
  'Mongolië': 'mn',
  'Montenegro': 'me',
  'Morocco': 'ma',
  'Marokko': 'ma',
  'Mozambique': 'mz',
  'Myanmar': 'mm',
  // N
  'Namibia': 'na',
  'Namibië': 'na',
  'Nauru': 'nr',
  'Nepal': 'np',
  'Netherlands': 'nl',
  'Nederland': 'nl',
  'New Zealand': 'nz',
  'Nieuw-Zeeland': 'nz',
  'Nicaragua': 'ni',
  'Niger': 'ne',
  'Nigeria': 'ng',
  'Norway': 'no',
  'Noorwegen': 'no',
  // O
  'Oman': 'om',
  // P
  'Pakistan': 'pk',
  'Palau': 'pw',
  'Palestine': 'ps',
  'Palestina': 'ps',
  'Panama': 'pa',
  'Papua New Guinea': 'pg',
  'Papoea-Nieuw-Guinea': 'pg',
  'Paraguay': 'py',
  'Peru': 'pe',
  'Philippines': 'ph',
  'Filipijnen': 'ph',
  'Poland': 'pl',
  'Polen': 'pl',
  'Portugal': 'pt',
  // Q
  'Qatar': 'qa',
  // R
  'Romania': 'ro',
  'Roemenië': 'ro',
  'Russia': 'ru',
  'Rusland': 'ru',
  'Rwanda': 'rw',
  // S
  'Saint Kitts and Nevis': 'kn',
  'Saint Lucia': 'lc',
  'Saint Vincent': 'vc',
  'Samoa': 'ws',
  'San Marino': 'sm',
  'Sao Tome and Principe': 'st',
  'Saudi Arabia': 'sa',
  'Saoedi-Arabië': 'sa',
  'Senegal': 'sn',
  'Serbia': 'rs',
  'Servië': 'rs',
  'Seychelles': 'sc',
  'Seychellen': 'sc',
  'Sierra Leone': 'sl',
  'Singapore': 'sg',
  'Slovakia': 'sk',
  'Slowakije': 'sk',
  'Slovenia': 'si',
  'Slovenië': 'si',
  'Solomon Islands': 'sb',
  'Salomonseilanden': 'sb',
  'Somalia': 'so',
  'Somalië': 'so',
  'South Africa': 'za',
  'Zuid-Afrika': 'za',
  'South Sudan': 'ss',
  'Zuid-Soedan': 'ss',
  'Spain': 'es',
  'Spanje': 'es',
  'Sri Lanka': 'lk',
  'Sudan': 'sd',
  'Soedan': 'sd',
  'Suriname': 'sr',
  'Sweden': 'se',
  'Zweden': 'se',
  'Switzerland': 'ch',
  'Zwitserland': 'ch',
  'Syria': 'sy',
  'Syrië': 'sy',
  // T
  'Taiwan': 'tw',
  'Tajikistan': 'tj',
  'Tadzjikistan': 'tj',
  'Tanzania': 'tz',
  'Thailand': 'th',
  'Timor-Leste': 'tl',
  'Oost-Timor': 'tl',
  'Togo': 'tg',
  'Tonga': 'to',
  'Trinidad and Tobago': 'tt',
  'Trinidad en Tobago': 'tt',
  'Tunisia': 'tn',
  'Tunesië': 'tn',
  'Turkey': 'tr',
  'Turkije': 'tr',
  'Turkmenistan': 'tm',
  'Tuvalu': 'tv',
  // U
  'Uganda': 'ug',
  'Oeganda': 'ug',
  'Ukraine': 'ua',
  'Oekraïne': 'ua',
  'United Arab Emirates': 'ae',
  'Verenigde Arabische Emiraten': 'ae',
  'UAE': 'ae',
  'VAE': 'ae',
  'Abu Dhabi': 'ae',
  'United Kingdom': 'gb',
  'Verenigd Koninkrijk': 'gb',
  'Great Britain': 'gb',
  'Groot-Brittannië': 'gb',
  'UK': 'gb',
  'United States': 'us',
  'Verenigde Staten': 'us',
  'USA': 'us',
  'Miami': 'us',
  'Las Vegas': 'us',
  'Uruguay': 'uy',
  'Uzbekistan': 'uz',
  'Oezbekistan': 'uz',
  // V
  'Vanuatu': 'vu',
  'Vatican': 'va',
  'Vaticaanstad': 'va',
  'Venezuela': 've',
  'Vietnam': 'vn',
  // Y
  'Yemen': 'ye',
  'Jemen': 'ye',
  // Z
  'Zambia': 'zm',
  'Zimbabwe': 'zw',
};

// Get flag image URL for a country (from flagcdn.com)
export const getCountryFlagUrl = (country) => {
  if (!country) return null;
  
  // Try exact match first
  let code = countryCodeMap[country];
  
  // Try case-insensitive match
  if (!code) {
    const lowerCountry = country.toLowerCase();
    for (const [key, value] of Object.entries(countryCodeMap)) {
      if (key.toLowerCase() === lowerCountry) {
        code = value;
        break;
      }
    }
  }
  
  if (code) {
    return `https://flagcdn.com/w640/${code}.png`;
  }
  return null;
};

// Get flag image URL for a race
export const getRaceFlagUrl = (race) => {
  if (!race) return null;
  
  // Try country field first
  if (race.country) {
    return getCountryFlagUrl(race.country);
  }
  
  // Try to extract country from race name
  const name = race.name || '';
  
  if (name.includes('Australian')) return getCountryFlagUrl('Australia');
  if (name.includes('Bahrain')) return getCountryFlagUrl('Bahrain');
  if (name.includes('Saudi')) return getCountryFlagUrl('Saudi Arabia');
  if (name.includes('Japanese') || name.includes('Japan')) return getCountryFlagUrl('Japan');
  if (name.includes('Chinese') || name.includes('China')) return getCountryFlagUrl('China');
  if (name.includes('Miami') || name.includes('Las Vegas') || name.includes('United States')) return getCountryFlagUrl('United States');
  if (name.includes('Monaco')) return getCountryFlagUrl('Monaco');
  if (name.includes('Canadian') || name.includes('Canada')) return getCountryFlagUrl('Canada');
  if (name.includes('Spanish') || name.includes('Spain')) return getCountryFlagUrl('Spain');
  if (name.includes('Austrian') || name.includes('Austria')) return getCountryFlagUrl('Austria');
  if (name.includes('British') || name.includes('Silverstone')) return getCountryFlagUrl('United Kingdom');
  if (name.includes('Hungarian') || name.includes('Hungary')) return getCountryFlagUrl('Hungary');
  if (name.includes('Belgian') || name.includes('Belgium') || name.includes('Spa')) return getCountryFlagUrl('Belgium');
  if (name.includes('Dutch') || name.includes('Netherlands') || name.includes('Zandvoort')) return getCountryFlagUrl('Netherlands');
  if (name.includes('Italian') || name.includes('Italy') || name.includes('Monza') || name.includes('Emilia')) return getCountryFlagUrl('Italy');
  if (name.includes('Singapore')) return getCountryFlagUrl('Singapore');
  if (name.includes('Azerbaijan') || name.includes('Baku')) return getCountryFlagUrl('Azerbaijan');
  if (name.includes('Mexican') || name.includes('Mexico')) return getCountryFlagUrl('Mexico');
  if (name.includes('Brazilian') || name.includes('Brazil') || name.includes('São Paulo')) return getCountryFlagUrl('Brazil');
  if (name.includes('Qatar')) return getCountryFlagUrl('Qatar');
  if (name.includes('Abu Dhabi')) return getCountryFlagUrl('United Arab Emirates');
  
  return null;
};

// Get flag emoji for a country
export const getCountryFlag = (country) => {
  if (!country) return '🏁';
  
  // Try exact match first
  if (countryFlags[country]) {
    return countryFlags[country];
  }
  
  // Try case-insensitive match
  const lowerCountry = country.toLowerCase();
  for (const [key, flag] of Object.entries(countryFlags)) {
    if (key.toLowerCase() === lowerCountry) {
      return flag;
    }
  }
  
  // Try partial match (for race names like "Australian Grand Prix")
  for (const [key, flag] of Object.entries(countryFlags)) {
    if (country.toLowerCase().includes(key.toLowerCase()) || 
        key.toLowerCase().includes(country.toLowerCase())) {
      return flag;
    }
  }
  
  // Default checkered flag
  return '🏁';
};

// Get small flag image URL for inline display (40px wide)
export const getCountryFlagIcon = (country) => {
  if (!country) return null;
  
  // Try exact match first
  let code = countryCodeMap[country];
  
  // Try case-insensitive match
  if (!code) {
    const lowerCountry = country.toLowerCase();
    for (const [key, value] of Object.entries(countryCodeMap)) {
      if (key.toLowerCase() === lowerCountry) {
        code = value;
        break;
      }
    }
  }
  
  if (code) {
    return `https://flagcdn.com/48x36/${code}.png`;
  }
  return null;
};

// Get flag for a race (tries country field first, then parses name)
// Accepts either a race object or a string (race name)
export const getRaceFlag = (raceOrName) => {
  if (!raceOrName) return '🏁';
  
  // If it's a string, treat it as the race name
  const name = typeof raceOrName === 'string' ? raceOrName : (raceOrName.name || '');
  const country = typeof raceOrName === 'object' ? raceOrName.country : null;
  
  // Try country field first (if object was passed)
  if (country) {
    return getCountryFlag(country);
  }
  
  // Check for specific GP names
  if (name.includes('Australian')) return '🇦🇺';
  if (name.includes('Bahrain')) return '🇧🇭';
  if (name.includes('Saudi Arabian') || name.includes('Saudi Arabia')) return '🇸🇦';
  if (name.includes('Japanese') || name.includes('Japan')) return '🇯🇵';
  if (name.includes('Chinese') || name.includes('China')) return '🇨🇳';
  if (name.includes('Miami')) return '🇺🇸';
  if (name.includes('Las Vegas')) return '🇺🇸';
  if (name.includes('United States') || name.includes('USA')) return '🇺🇸';
  if (name.includes('Emilia') || name.includes('Italian') || name.includes('Monza')) return '🇮🇹';
  if (name.includes('Monaco')) return '🇲🇨';
  if (name.includes('Canadian') || name.includes('Canada')) return '🇨🇦';
  if (name.includes('Spanish') || name.includes('Spain') || name.includes('Barcelona')) return '🇪🇸';
  if (name.includes('Austrian') || name.includes('Austria')) return '🇦🇹';
  if (name.includes('British') || name.includes('Silverstone')) return '🇬🇧';
  if (name.includes('Hungarian') || name.includes('Hungary')) return '🇭🇺';
  if (name.includes('Belgian') || name.includes('Belgium') || name.includes('Spa')) return '🇧🇪';
  if (name.includes('Dutch') || name.includes('Netherlands') || name.includes('Zandvoort')) return '🇳🇱';
  if (name.includes('Singapore')) return '🇸🇬';
  if (name.includes('Azerbaijan') || name.includes('Baku')) return '🇦🇿';
  if (name.includes('Mexican') || name.includes('Mexico')) return '🇲🇽';
  if (name.includes('Brazilian') || name.includes('Brazil') || name.includes('São Paulo')) return '🇧🇷';
  if (name.includes('Qatar')) return '🇶🇦';
  if (name.includes('Abu Dhabi')) return '🇦🇪';
  
  return '🏁';
};

// Get flag icon URL for a race
export const getRaceFlagIcon = (race) => {
  if (!race) return null;
  
  // Try country field first
  if (race.country) {
    return getCountryFlagIcon(race.country);
  }
  
  // Try to extract country from race name
  const name = typeof race === 'string' ? race : (race.name || '');
  
  if (name.includes('Australian')) return getCountryFlagIcon('Australia');
  if (name.includes('Bahrain')) return getCountryFlagIcon('Bahrain');
  if (name.includes('Saudi Arabian') || name.includes('Saudi Arabia')) return getCountryFlagIcon('Saudi Arabia');
  if (name.includes('Japanese') || name.includes('Japan')) return getCountryFlagIcon('Japan');
  if (name.includes('Chinese') || name.includes('China')) return getCountryFlagIcon('China');
  if (name.includes('Miami') || name.includes('Las Vegas') || name.includes('United States')) return getCountryFlagIcon('United States');
  if (name.includes('Emilia') || name.includes('Italian') || name.includes('Monza')) return getCountryFlagIcon('Italy');
  if (name.includes('Monaco')) return getCountryFlagIcon('Monaco');
  if (name.includes('Canadian') || name.includes('Canada')) return getCountryFlagIcon('Canada');
  if (name.includes('Spanish') || name.includes('Spain') || name.includes('Barcelona')) return getCountryFlagIcon('Spain');
  if (name.includes('Austrian') || name.includes('Austria')) return getCountryFlagIcon('Austria');
  if (name.includes('British') || name.includes('Silverstone')) return getCountryFlagIcon('United Kingdom');
  if (name.includes('Hungarian') || name.includes('Hungary')) return getCountryFlagIcon('Hungary');
  if (name.includes('Belgian') || name.includes('Belgium') || name.includes('Spa')) return getCountryFlagIcon('Belgium');
  if (name.includes('Dutch') || name.includes('Netherlands') || name.includes('Zandvoort')) return getCountryFlagIcon('Netherlands');
  if (name.includes('Singapore')) return getCountryFlagIcon('Singapore');
  if (name.includes('Azerbaijan') || name.includes('Baku')) return getCountryFlagIcon('Azerbaijan');
  if (name.includes('Mexican') || name.includes('Mexico')) return getCountryFlagIcon('Mexico');
  if (name.includes('Brazilian') || name.includes('Brazil') || name.includes('São Paulo')) return getCountryFlagIcon('Brazil');
  if (name.includes('Qatar')) return getCountryFlagIcon('Qatar');
  if (name.includes('Abu Dhabi')) return getCountryFlagIcon('United Arab Emirates');
  
  return null;
};

// React component for displaying a flag image inline
// Usage: <FlagImage race={race} /> or <FlagImage country="Netherlands" />
export const FlagImage = ({ race, country, className = "inline-block w-5 h-4 mr-1.5 rounded-sm object-cover" }) => {
  let flagUrl = null;
  
  if (race) {
    flagUrl = getRaceFlagIcon(race);
  } else if (country) {
    flagUrl = getCountryFlagIcon(country);
  }
  
  if (!flagUrl) {
    return <span className="inline-block w-5 mr-1.5">🏁</span>;
  }
  
  return (
    <img 
      src={flagUrl} 
      alt="" 
      className={className}
      onError={(e) => { e.target.style.display = 'none'; }}
    />
  );
};

export default { getCountryFlag, getRaceFlag, getCountryFlagUrl, getRaceFlagUrl, getCountryFlagIcon, getRaceFlagIcon, FlagImage };
